import { Component } from '@angular/core';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent {}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/components/not-found/not-found.component.ts